// removed by extract-text-webpack-plugin
module.exports = {"punchCardWrap":"qempo_PunchCard_punchCardWrap-3vkb_1F","disabled":"qempo_PunchCard_disabled-3l9tiOc","title":"qempo_PunchCard_title-32GIbRL","claim":"qempo_PunchCard_claim-1u2sMVU","subtitle":"qempo_PunchCard_subtitle-33P1aBU","question":"qempo_PunchCard_question-2nUt9if","pointsWrap":"qempo_PunchCard_pointsWrap-13oc5Ol","starsWrap":"qempo_PunchCard_starsWrap-34aWFto","full":"qempo_PunchCard_full-E1UkaR6","empty":"qempo_PunchCard_empty-3j_GQTX","giftWrap":"qempo_PunchCard_giftWrap-1Dh9Xu6","active":"qempo_PunchCard_active-2_D4ucL"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/punch-card/components/PunchCard.scss
// module id = 1343
// module chunks = 0